import * as React from 'react'

import * as moment from 'moment'
import 'moment/locale/pl'

import { Provider } from 'react-redux'
import { hot } from 'react-hot-loader'

import { ConnectedRouter } from 'connected-react-router'

import { Routes } from './routes/routes'

import { ScrollToTop } from './common/ui'
import { store, history } from './redux/store'

moment.locale('pl')

class AppInner extends React.Component<{}, {}> {
  render() {
    return <Routes />
  }
}

const M =
  process.env.NODE_ENV === 'development' ? hot(module)(AppInner) : AppInner

class AppContainer extends React.Component<{}, {}> {
  public render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ScrollToTop>
            <M />
          </ScrollToTop>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default AppContainer
